export default __webpack_public_path__ + "static/media/HelpIcon.2940cb9a.svg";